// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v5.29.3
// source: sdk_zapi.proto
/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { sdk_AudioFormatFromJSON, sdk_AudioFormatToJSON } from "./sdk";
export const protobufPackage = "taf";
function createBaseSdkZapi() {
    return {};
}
export const SdkZapi = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdkZapi();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return SdkZapi.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSdkZapi();
        return message;
    },
};
function createBaseSdkZapi_PlayOptions() {
    return {
        pin: undefined,
        preferredAudioLanguage: undefined,
        preferredSubtitlesLanguage: undefined,
        startupPosition: undefined,
        drmRequired: undefined,
        fairPlayCertificateUrl: undefined,
        tcString: undefined,
        preferredAudioFormat: undefined,
        gt12ChannelInfo: undefined,
        autoplay: undefined,
        adid: undefined,
        thumbnails: undefined,
    };
}
export const SdkZapi_PlayOptions = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.pin !== undefined) {
            writer.uint32(10).string(message.pin);
        }
        if (message.preferredAudioLanguage !== undefined) {
            writer.uint32(18).string(message.preferredAudioLanguage);
        }
        if (message.preferredSubtitlesLanguage !== undefined) {
            writer.uint32(26).string(message.preferredSubtitlesLanguage);
        }
        if (message.startupPosition !== undefined) {
            writer.uint32(33).double(message.startupPosition);
        }
        if (message.drmRequired !== undefined) {
            writer.uint32(40).bool(message.drmRequired);
        }
        if (message.fairPlayCertificateUrl !== undefined) {
            writer.uint32(58).string(message.fairPlayCertificateUrl);
        }
        if (message.tcString !== undefined) {
            writer.uint32(90).string(message.tcString);
        }
        if (message.preferredAudioFormat !== undefined) {
            writer.uint32(64).int32(message.preferredAudioFormat);
        }
        if (message.gt12ChannelInfo !== undefined) {
            SdkZapi_PlayOptions_GT12ChannelInfo.encode(message.gt12ChannelInfo, writer.uint32(82).fork()).ldelim();
        }
        if (message.autoplay !== undefined) {
            writer.uint32(192).bool(message.autoplay);
        }
        if (message.adid !== undefined) {
            writer.uint32(202).string(message.adid);
        }
        if (message.thumbnails !== undefined) {
            writer.uint32(208).bool(message.thumbnails);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdkZapi_PlayOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.pin = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.preferredAudioLanguage = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.preferredSubtitlesLanguage = reader.string();
                    continue;
                case 4:
                    if (tag !== 33) {
                        break;
                    }
                    message.startupPosition = reader.double();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.drmRequired = reader.bool();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.fairPlayCertificateUrl = reader.string();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.tcString = reader.string();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.preferredAudioFormat = reader.int32();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.gt12ChannelInfo = SdkZapi_PlayOptions_GT12ChannelInfo.decode(reader, reader.uint32());
                    continue;
                case 24:
                    if (tag !== 192) {
                        break;
                    }
                    message.autoplay = reader.bool();
                    continue;
                case 25:
                    if (tag !== 202) {
                        break;
                    }
                    message.adid = reader.string();
                    continue;
                case 26:
                    if (tag !== 208) {
                        break;
                    }
                    message.thumbnails = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pin: isSet(object.pin) ? globalThis.String(object.pin) : undefined,
            preferredAudioLanguage: isSet(object.preferredAudioLanguage)
                ? globalThis.String(object.preferredAudioLanguage)
                : undefined,
            preferredSubtitlesLanguage: isSet(object.preferredSubtitlesLanguage)
                ? globalThis.String(object.preferredSubtitlesLanguage)
                : undefined,
            startupPosition: isSet(object.startupPosition) ? globalThis.Number(object.startupPosition) : undefined,
            drmRequired: isSet(object.drmRequired) ? globalThis.Boolean(object.drmRequired) : undefined,
            fairPlayCertificateUrl: isSet(object.fairPlayCertificateUrl)
                ? globalThis.String(object.fairPlayCertificateUrl)
                : undefined,
            tcString: isSet(object.tcString) ? globalThis.String(object.tcString) : undefined,
            preferredAudioFormat: isSet(object.preferredAudioFormat)
                ? sdk_AudioFormatFromJSON(object.preferredAudioFormat)
                : undefined,
            gt12ChannelInfo: isSet(object.gt12ChannelInfo)
                ? SdkZapi_PlayOptions_GT12ChannelInfo.fromJSON(object.gt12ChannelInfo)
                : undefined,
            autoplay: isSet(object.autoplay) ? globalThis.Boolean(object.autoplay) : undefined,
            adid: isSet(object.adid) ? globalThis.String(object.adid) : undefined,
            thumbnails: isSet(object.thumbnails) ? globalThis.Boolean(object.thumbnails) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pin !== undefined) {
            obj.pin = message.pin;
        }
        if (message.preferredAudioLanguage !== undefined) {
            obj.preferredAudioLanguage = message.preferredAudioLanguage;
        }
        if (message.preferredSubtitlesLanguage !== undefined) {
            obj.preferredSubtitlesLanguage = message.preferredSubtitlesLanguage;
        }
        if (message.startupPosition !== undefined) {
            obj.startupPosition = message.startupPosition;
        }
        if (message.drmRequired !== undefined) {
            obj.drmRequired = message.drmRequired;
        }
        if (message.fairPlayCertificateUrl !== undefined) {
            obj.fairPlayCertificateUrl = message.fairPlayCertificateUrl;
        }
        if (message.tcString !== undefined) {
            obj.tcString = message.tcString;
        }
        if (message.preferredAudioFormat !== undefined) {
            obj.preferredAudioFormat = sdk_AudioFormatToJSON(message.preferredAudioFormat);
        }
        if (message.gt12ChannelInfo !== undefined) {
            obj.gt12ChannelInfo = SdkZapi_PlayOptions_GT12ChannelInfo.toJSON(message.gt12ChannelInfo);
        }
        if (message.autoplay !== undefined) {
            obj.autoplay = message.autoplay;
        }
        if (message.adid !== undefined) {
            obj.adid = message.adid;
        }
        if (message.thumbnails !== undefined) {
            obj.thumbnails = message.thumbnails;
        }
        return obj;
    },
    create(base) {
        return SdkZapi_PlayOptions.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdkZapi_PlayOptions();
        message.pin = object.pin ?? undefined;
        message.preferredAudioLanguage = object.preferredAudioLanguage ?? undefined;
        message.preferredSubtitlesLanguage = object.preferredSubtitlesLanguage ?? undefined;
        message.startupPosition = object.startupPosition ?? undefined;
        message.drmRequired = object.drmRequired ?? undefined;
        message.fairPlayCertificateUrl = object.fairPlayCertificateUrl ?? undefined;
        message.tcString = object.tcString ?? undefined;
        message.preferredAudioFormat = object.preferredAudioFormat ?? undefined;
        message.gt12ChannelInfo = (object.gt12ChannelInfo !== undefined && object.gt12ChannelInfo !== null)
            ? SdkZapi_PlayOptions_GT12ChannelInfo.fromPartial(object.gt12ChannelInfo)
            : undefined;
        message.autoplay = object.autoplay ?? undefined;
        message.adid = object.adid ?? undefined;
        message.thumbnails = object.thumbnails ?? undefined;
        return message;
    },
};
function createBaseSdkZapi_PlayOptions_GT12ChannelInfo() {
    return { isGT12BV: false, forwardSeekingNeedsMarkers: false, adBreakSkipAllowed: false, disableStartAd: undefined };
}
export const SdkZapi_PlayOptions_GT12ChannelInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.isGT12BV !== false) {
            writer.uint32(8).bool(message.isGT12BV);
        }
        if (message.forwardSeekingNeedsMarkers !== false) {
            writer.uint32(16).bool(message.forwardSeekingNeedsMarkers);
        }
        if (message.adBreakSkipAllowed !== false) {
            writer.uint32(24).bool(message.adBreakSkipAllowed);
        }
        if (message.disableStartAd !== undefined) {
            writer.uint32(32).bool(message.disableStartAd);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdkZapi_PlayOptions_GT12ChannelInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.isGT12BV = reader.bool();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.forwardSeekingNeedsMarkers = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.adBreakSkipAllowed = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.disableStartAd = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            isGT12BV: isSet(object.isGT12BV) ? globalThis.Boolean(object.isGT12BV) : false,
            forwardSeekingNeedsMarkers: isSet(object.forwardSeekingNeedsMarkers)
                ? globalThis.Boolean(object.forwardSeekingNeedsMarkers)
                : false,
            adBreakSkipAllowed: isSet(object.adBreakSkipAllowed) ? globalThis.Boolean(object.adBreakSkipAllowed) : false,
            disableStartAd: isSet(object.disableStartAd) ? globalThis.Boolean(object.disableStartAd) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.isGT12BV !== false) {
            obj.isGT12BV = message.isGT12BV;
        }
        if (message.forwardSeekingNeedsMarkers !== false) {
            obj.forwardSeekingNeedsMarkers = message.forwardSeekingNeedsMarkers;
        }
        if (message.adBreakSkipAllowed !== false) {
            obj.adBreakSkipAllowed = message.adBreakSkipAllowed;
        }
        if (message.disableStartAd !== undefined) {
            obj.disableStartAd = message.disableStartAd;
        }
        return obj;
    },
    create(base) {
        return SdkZapi_PlayOptions_GT12ChannelInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdkZapi_PlayOptions_GT12ChannelInfo();
        message.isGT12BV = object.isGT12BV ?? false;
        message.forwardSeekingNeedsMarkers = object.forwardSeekingNeedsMarkers ?? false;
        message.adBreakSkipAllowed = object.adBreakSkipAllowed ?? false;
        message.disableStartAd = object.disableStartAd ?? undefined;
        return message;
    },
};
function createBaseSdkZapi_Action() {
    return {
        playerCreate: undefined,
        playerPlayLive: undefined,
        playerPlayVod: undefined,
        playerPlayProgram: undefined,
        playerPlayRecording: undefined,
        playerPlayVodTrailer: undefined,
    };
}
export const SdkZapi_Action = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.playerCreate !== undefined) {
            SdkZapi_Player_Create.encode(message.playerCreate, writer.uint32(10).fork()).ldelim();
        }
        if (message.playerPlayLive !== undefined) {
            SdkZapi_Player_PlayLive.encode(message.playerPlayLive, writer.uint32(18).fork()).ldelim();
        }
        if (message.playerPlayVod !== undefined) {
            SdkZapi_Player_PlayVod.encode(message.playerPlayVod, writer.uint32(26).fork()).ldelim();
        }
        if (message.playerPlayProgram !== undefined) {
            SdkZapi_Player_PlayProgram.encode(message.playerPlayProgram, writer.uint32(34).fork()).ldelim();
        }
        if (message.playerPlayRecording !== undefined) {
            SdkZapi_Player_PlayRecording.encode(message.playerPlayRecording, writer.uint32(42).fork()).ldelim();
        }
        if (message.playerPlayVodTrailer !== undefined) {
            SdkZapi_Player_PlayVodTrailer.encode(message.playerPlayVodTrailer, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdkZapi_Action();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.playerCreate = SdkZapi_Player_Create.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.playerPlayLive = SdkZapi_Player_PlayLive.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.playerPlayVod = SdkZapi_Player_PlayVod.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.playerPlayProgram = SdkZapi_Player_PlayProgram.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.playerPlayRecording = SdkZapi_Player_PlayRecording.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.playerPlayVodTrailer = SdkZapi_Player_PlayVodTrailer.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            playerCreate: isSet(object.playerCreate) ? SdkZapi_Player_Create.fromJSON(object.playerCreate) : undefined,
            playerPlayLive: isSet(object.playerPlayLive)
                ? SdkZapi_Player_PlayLive.fromJSON(object.playerPlayLive)
                : undefined,
            playerPlayVod: isSet(object.playerPlayVod) ? SdkZapi_Player_PlayVod.fromJSON(object.playerPlayVod) : undefined,
            playerPlayProgram: isSet(object.playerPlayProgram)
                ? SdkZapi_Player_PlayProgram.fromJSON(object.playerPlayProgram)
                : undefined,
            playerPlayRecording: isSet(object.playerPlayRecording)
                ? SdkZapi_Player_PlayRecording.fromJSON(object.playerPlayRecording)
                : undefined,
            playerPlayVodTrailer: isSet(object.playerPlayVodTrailer)
                ? SdkZapi_Player_PlayVodTrailer.fromJSON(object.playerPlayVodTrailer)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.playerCreate !== undefined) {
            obj.playerCreate = SdkZapi_Player_Create.toJSON(message.playerCreate);
        }
        if (message.playerPlayLive !== undefined) {
            obj.playerPlayLive = SdkZapi_Player_PlayLive.toJSON(message.playerPlayLive);
        }
        if (message.playerPlayVod !== undefined) {
            obj.playerPlayVod = SdkZapi_Player_PlayVod.toJSON(message.playerPlayVod);
        }
        if (message.playerPlayProgram !== undefined) {
            obj.playerPlayProgram = SdkZapi_Player_PlayProgram.toJSON(message.playerPlayProgram);
        }
        if (message.playerPlayRecording !== undefined) {
            obj.playerPlayRecording = SdkZapi_Player_PlayRecording.toJSON(message.playerPlayRecording);
        }
        if (message.playerPlayVodTrailer !== undefined) {
            obj.playerPlayVodTrailer = SdkZapi_Player_PlayVodTrailer.toJSON(message.playerPlayVodTrailer);
        }
        return obj;
    },
    create(base) {
        return SdkZapi_Action.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdkZapi_Action();
        message.playerCreate = (object.playerCreate !== undefined && object.playerCreate !== null)
            ? SdkZapi_Player_Create.fromPartial(object.playerCreate)
            : undefined;
        message.playerPlayLive = (object.playerPlayLive !== undefined && object.playerPlayLive !== null)
            ? SdkZapi_Player_PlayLive.fromPartial(object.playerPlayLive)
            : undefined;
        message.playerPlayVod = (object.playerPlayVod !== undefined && object.playerPlayVod !== null)
            ? SdkZapi_Player_PlayVod.fromPartial(object.playerPlayVod)
            : undefined;
        message.playerPlayProgram = (object.playerPlayProgram !== undefined && object.playerPlayProgram !== null)
            ? SdkZapi_Player_PlayProgram.fromPartial(object.playerPlayProgram)
            : undefined;
        message.playerPlayRecording = (object.playerPlayRecording !== undefined && object.playerPlayRecording !== null)
            ? SdkZapi_Player_PlayRecording.fromPartial(object.playerPlayRecording)
            : undefined;
        message.playerPlayVodTrailer = (object.playerPlayVodTrailer !== undefined && object.playerPlayVodTrailer !== null)
            ? SdkZapi_Player_PlayVodTrailer.fromPartial(object.playerPlayVodTrailer)
            : undefined;
        return message;
    },
};
function createBaseSdkZapi_Player() {
    return {};
}
export const SdkZapi_Player = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdkZapi_Player();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return SdkZapi_Player.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSdkZapi_Player();
        return message;
    },
};
function createBaseSdkZapi_Player_Create() {
    return { options: undefined };
}
export const SdkZapi_Player_Create = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.options !== undefined) {
            SdkZapi_Player_Create_PlayerOptions.encode(message.options, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdkZapi_Player_Create();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.options = SdkZapi_Player_Create_PlayerOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            options: isSet(object.options) ? SdkZapi_Player_Create_PlayerOptions.fromJSON(object.options) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.options !== undefined) {
            obj.options = SdkZapi_Player_Create_PlayerOptions.toJSON(message.options);
        }
        return obj;
    },
    create(base) {
        return SdkZapi_Player_Create.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdkZapi_Player_Create();
        message.options = (object.options !== undefined && object.options !== null)
            ? SdkZapi_Player_Create_PlayerOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBaseSdkZapi_Player_Create_PlayerOptions() {
    return {
        host: undefined,
        publicId: undefined,
        appVersion: undefined,
        appId: undefined,
        appName: undefined,
        license: undefined,
        licenseValidationUrl: undefined,
        stepBackwardDuration: undefined,
        stepForwardDuration: undefined,
        muted: undefined,
        latencyMeasurementInterval: undefined,
        enableOpenMeasurement: undefined,
        enableMediaSession: undefined,
    };
}
export const SdkZapi_Player_Create_PlayerOptions = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.host !== undefined) {
            writer.uint32(10).string(message.host);
        }
        if (message.publicId !== undefined) {
            writer.uint32(34).string(message.publicId);
        }
        if (message.appVersion !== undefined) {
            writer.uint32(42).string(message.appVersion);
        }
        if (message.appId !== undefined) {
            writer.uint32(48).uint32(message.appId);
        }
        if (message.appName !== undefined) {
            writer.uint32(82).string(message.appName);
        }
        if (message.license !== undefined) {
            writer.uint32(90).string(message.license);
        }
        if (message.licenseValidationUrl !== undefined) {
            writer.uint32(98).string(message.licenseValidationUrl);
        }
        if (message.stepBackwardDuration !== undefined) {
            writer.uint32(61).float(message.stepBackwardDuration);
        }
        if (message.stepForwardDuration !== undefined) {
            writer.uint32(69).float(message.stepForwardDuration);
        }
        if (message.muted !== undefined) {
            writer.uint32(72).bool(message.muted);
        }
        if (message.latencyMeasurementInterval !== undefined) {
            writer.uint32(104).int32(message.latencyMeasurementInterval);
        }
        if (message.enableOpenMeasurement !== undefined) {
            writer.uint32(112).bool(message.enableOpenMeasurement);
        }
        if (message.enableMediaSession !== undefined) {
            writer.uint32(120).bool(message.enableMediaSession);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdkZapi_Player_Create_PlayerOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.host = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.publicId = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.appVersion = reader.string();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.appId = reader.uint32();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.appName = reader.string();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.license = reader.string();
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.licenseValidationUrl = reader.string();
                    continue;
                case 7:
                    if (tag !== 61) {
                        break;
                    }
                    message.stepBackwardDuration = reader.float();
                    continue;
                case 8:
                    if (tag !== 69) {
                        break;
                    }
                    message.stepForwardDuration = reader.float();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.muted = reader.bool();
                    continue;
                case 13:
                    if (tag !== 104) {
                        break;
                    }
                    message.latencyMeasurementInterval = reader.int32();
                    continue;
                case 14:
                    if (tag !== 112) {
                        break;
                    }
                    message.enableOpenMeasurement = reader.bool();
                    continue;
                case 15:
                    if (tag !== 120) {
                        break;
                    }
                    message.enableMediaSession = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            host: isSet(object.host) ? globalThis.String(object.host) : undefined,
            publicId: isSet(object.publicId) ? globalThis.String(object.publicId) : undefined,
            appVersion: isSet(object.appVersion) ? globalThis.String(object.appVersion) : undefined,
            appId: isSet(object.appId) ? globalThis.Number(object.appId) : undefined,
            appName: isSet(object.appName) ? globalThis.String(object.appName) : undefined,
            license: isSet(object.license) ? globalThis.String(object.license) : undefined,
            licenseValidationUrl: isSet(object.licenseValidationUrl)
                ? globalThis.String(object.licenseValidationUrl)
                : undefined,
            stepBackwardDuration: isSet(object.stepBackwardDuration)
                ? globalThis.Number(object.stepBackwardDuration)
                : undefined,
            stepForwardDuration: isSet(object.stepForwardDuration)
                ? globalThis.Number(object.stepForwardDuration)
                : undefined,
            muted: isSet(object.muted) ? globalThis.Boolean(object.muted) : undefined,
            latencyMeasurementInterval: isSet(object.latencyMeasurementInterval)
                ? globalThis.Number(object.latencyMeasurementInterval)
                : undefined,
            enableOpenMeasurement: isSet(object.enableOpenMeasurement)
                ? globalThis.Boolean(object.enableOpenMeasurement)
                : undefined,
            enableMediaSession: isSet(object.enableMediaSession) ? globalThis.Boolean(object.enableMediaSession) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.host !== undefined) {
            obj.host = message.host;
        }
        if (message.publicId !== undefined) {
            obj.publicId = message.publicId;
        }
        if (message.appVersion !== undefined) {
            obj.appVersion = message.appVersion;
        }
        if (message.appId !== undefined) {
            obj.appId = Math.round(message.appId);
        }
        if (message.appName !== undefined) {
            obj.appName = message.appName;
        }
        if (message.license !== undefined) {
            obj.license = message.license;
        }
        if (message.licenseValidationUrl !== undefined) {
            obj.licenseValidationUrl = message.licenseValidationUrl;
        }
        if (message.stepBackwardDuration !== undefined) {
            obj.stepBackwardDuration = message.stepBackwardDuration;
        }
        if (message.stepForwardDuration !== undefined) {
            obj.stepForwardDuration = message.stepForwardDuration;
        }
        if (message.muted !== undefined) {
            obj.muted = message.muted;
        }
        if (message.latencyMeasurementInterval !== undefined) {
            obj.latencyMeasurementInterval = Math.round(message.latencyMeasurementInterval);
        }
        if (message.enableOpenMeasurement !== undefined) {
            obj.enableOpenMeasurement = message.enableOpenMeasurement;
        }
        if (message.enableMediaSession !== undefined) {
            obj.enableMediaSession = message.enableMediaSession;
        }
        return obj;
    },
    create(base) {
        return SdkZapi_Player_Create_PlayerOptions.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdkZapi_Player_Create_PlayerOptions();
        message.host = object.host ?? undefined;
        message.publicId = object.publicId ?? undefined;
        message.appVersion = object.appVersion ?? undefined;
        message.appId = object.appId ?? undefined;
        message.appName = object.appName ?? undefined;
        message.license = object.license ?? undefined;
        message.licenseValidationUrl = object.licenseValidationUrl ?? undefined;
        message.stepBackwardDuration = object.stepBackwardDuration ?? undefined;
        message.stepForwardDuration = object.stepForwardDuration ?? undefined;
        message.muted = object.muted ?? undefined;
        message.latencyMeasurementInterval = object.latencyMeasurementInterval ?? undefined;
        message.enableOpenMeasurement = object.enableOpenMeasurement ?? undefined;
        message.enableMediaSession = object.enableMediaSession ?? undefined;
        return message;
    },
};
function createBaseSdkZapi_Player_ProgramInfo() {
    return { cid: "", programId: "", start: 0, end: 0, programTitle: "", episodeTitle: undefined };
}
export const SdkZapi_Player_ProgramInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.cid !== "") {
            writer.uint32(10).string(message.cid);
        }
        if (message.programId !== "") {
            writer.uint32(18).string(message.programId);
        }
        if (message.start !== 0) {
            writer.uint32(24).uint64(message.start);
        }
        if (message.end !== 0) {
            writer.uint32(32).uint64(message.end);
        }
        if (message.programTitle !== "") {
            writer.uint32(42).string(message.programTitle);
        }
        if (message.episodeTitle !== undefined) {
            writer.uint32(50).string(message.episodeTitle);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdkZapi_Player_ProgramInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.cid = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.programId = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.start = longToNumber(reader.uint64());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.end = longToNumber(reader.uint64());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.programTitle = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.episodeTitle = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            cid: isSet(object.cid) ? globalThis.String(object.cid) : "",
            programId: isSet(object.programId) ? globalThis.String(object.programId) : "",
            start: isSet(object.start) ? globalThis.Number(object.start) : 0,
            end: isSet(object.end) ? globalThis.Number(object.end) : 0,
            programTitle: isSet(object.programTitle) ? globalThis.String(object.programTitle) : "",
            episodeTitle: isSet(object.episodeTitle) ? globalThis.String(object.episodeTitle) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.cid !== "") {
            obj.cid = message.cid;
        }
        if (message.programId !== "") {
            obj.programId = message.programId;
        }
        if (message.start !== 0) {
            obj.start = Math.round(message.start);
        }
        if (message.end !== 0) {
            obj.end = Math.round(message.end);
        }
        if (message.programTitle !== "") {
            obj.programTitle = message.programTitle;
        }
        if (message.episodeTitle !== undefined) {
            obj.episodeTitle = message.episodeTitle;
        }
        return obj;
    },
    create(base) {
        return SdkZapi_Player_ProgramInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdkZapi_Player_ProgramInfo();
        message.cid = object.cid ?? "";
        message.programId = object.programId ?? "";
        message.start = object.start ?? 0;
        message.end = object.end ?? 0;
        message.programTitle = object.programTitle ?? "";
        message.episodeTitle = object.episodeTitle ?? undefined;
        return message;
    },
};
function createBaseSdkZapi_Player_PlayLive() {
    return { cid: "", options: undefined, programInfo: undefined };
}
export const SdkZapi_Player_PlayLive = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.cid !== "") {
            writer.uint32(10).string(message.cid);
        }
        if (message.options !== undefined) {
            SdkZapi_PlayOptions.encode(message.options, writer.uint32(18).fork()).ldelim();
        }
        if (message.programInfo !== undefined) {
            SdkZapi_Player_ProgramInfo.encode(message.programInfo, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdkZapi_Player_PlayLive();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.cid = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.options = SdkZapi_PlayOptions.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.programInfo = SdkZapi_Player_ProgramInfo.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            cid: isSet(object.cid) ? globalThis.String(object.cid) : "",
            options: isSet(object.options) ? SdkZapi_PlayOptions.fromJSON(object.options) : undefined,
            programInfo: isSet(object.programInfo) ? SdkZapi_Player_ProgramInfo.fromJSON(object.programInfo) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.cid !== "") {
            obj.cid = message.cid;
        }
        if (message.options !== undefined) {
            obj.options = SdkZapi_PlayOptions.toJSON(message.options);
        }
        if (message.programInfo !== undefined) {
            obj.programInfo = SdkZapi_Player_ProgramInfo.toJSON(message.programInfo);
        }
        return obj;
    },
    create(base) {
        return SdkZapi_Player_PlayLive.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdkZapi_Player_PlayLive();
        message.cid = object.cid ?? "";
        message.options = (object.options !== undefined && object.options !== null)
            ? SdkZapi_PlayOptions.fromPartial(object.options)
            : undefined;
        message.programInfo = (object.programInfo !== undefined && object.programInfo !== null)
            ? SdkZapi_Player_ProgramInfo.fromPartial(object.programInfo)
            : undefined;
        return message;
    },
};
function createBaseSdkZapi_Player_PlayVod() {
    return {
        teasableType: "",
        termToken: "",
        teasableId: "",
        streamId: undefined,
        streamProviderId: undefined,
        options: undefined,
    };
}
export const SdkZapi_Player_PlayVod = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.teasableType !== "") {
            writer.uint32(10).string(message.teasableType);
        }
        if (message.termToken !== "") {
            writer.uint32(18).string(message.termToken);
        }
        if (message.teasableId !== "") {
            writer.uint32(26).string(message.teasableId);
        }
        if (message.streamId !== undefined) {
            writer.uint32(34).string(message.streamId);
        }
        if (message.streamProviderId !== undefined) {
            writer.uint32(42).string(message.streamProviderId);
        }
        if (message.options !== undefined) {
            SdkZapi_PlayOptions.encode(message.options, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdkZapi_Player_PlayVod();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.teasableType = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.termToken = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.teasableId = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.streamId = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.streamProviderId = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.options = SdkZapi_PlayOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            teasableType: isSet(object.teasableType) ? globalThis.String(object.teasableType) : "",
            termToken: isSet(object.termToken) ? globalThis.String(object.termToken) : "",
            teasableId: isSet(object.teasableId) ? globalThis.String(object.teasableId) : "",
            streamId: isSet(object.streamId) ? globalThis.String(object.streamId) : undefined,
            streamProviderId: isSet(object.streamProviderId) ? globalThis.String(object.streamProviderId) : undefined,
            options: isSet(object.options) ? SdkZapi_PlayOptions.fromJSON(object.options) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.teasableType !== "") {
            obj.teasableType = message.teasableType;
        }
        if (message.termToken !== "") {
            obj.termToken = message.termToken;
        }
        if (message.teasableId !== "") {
            obj.teasableId = message.teasableId;
        }
        if (message.streamId !== undefined) {
            obj.streamId = message.streamId;
        }
        if (message.streamProviderId !== undefined) {
            obj.streamProviderId = message.streamProviderId;
        }
        if (message.options !== undefined) {
            obj.options = SdkZapi_PlayOptions.toJSON(message.options);
        }
        return obj;
    },
    create(base) {
        return SdkZapi_Player_PlayVod.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdkZapi_Player_PlayVod();
        message.teasableType = object.teasableType ?? "";
        message.termToken = object.termToken ?? "";
        message.teasableId = object.teasableId ?? "";
        message.streamId = object.streamId ?? undefined;
        message.streamProviderId = object.streamProviderId ?? undefined;
        message.options = (object.options !== undefined && object.options !== null)
            ? SdkZapi_PlayOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBaseSdkZapi_Player_PlayProgram() {
    return { cid: "", programId: 0, options: undefined, programInfo: undefined };
}
export const SdkZapi_Player_PlayProgram = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.cid !== "") {
            writer.uint32(10).string(message.cid);
        }
        if (message.programId !== 0) {
            writer.uint32(16).uint32(message.programId);
        }
        if (message.options !== undefined) {
            SdkZapi_PlayOptions.encode(message.options, writer.uint32(26).fork()).ldelim();
        }
        if (message.programInfo !== undefined) {
            SdkZapi_Player_ProgramInfo.encode(message.programInfo, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdkZapi_Player_PlayProgram();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.cid = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.programId = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.options = SdkZapi_PlayOptions.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.programInfo = SdkZapi_Player_ProgramInfo.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            cid: isSet(object.cid) ? globalThis.String(object.cid) : "",
            programId: isSet(object.programId) ? globalThis.Number(object.programId) : 0,
            options: isSet(object.options) ? SdkZapi_PlayOptions.fromJSON(object.options) : undefined,
            programInfo: isSet(object.programInfo) ? SdkZapi_Player_ProgramInfo.fromJSON(object.programInfo) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.cid !== "") {
            obj.cid = message.cid;
        }
        if (message.programId !== 0) {
            obj.programId = Math.round(message.programId);
        }
        if (message.options !== undefined) {
            obj.options = SdkZapi_PlayOptions.toJSON(message.options);
        }
        if (message.programInfo !== undefined) {
            obj.programInfo = SdkZapi_Player_ProgramInfo.toJSON(message.programInfo);
        }
        return obj;
    },
    create(base) {
        return SdkZapi_Player_PlayProgram.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdkZapi_Player_PlayProgram();
        message.cid = object.cid ?? "";
        message.programId = object.programId ?? 0;
        message.options = (object.options !== undefined && object.options !== null)
            ? SdkZapi_PlayOptions.fromPartial(object.options)
            : undefined;
        message.programInfo = (object.programInfo !== undefined && object.programInfo !== null)
            ? SdkZapi_Player_ProgramInfo.fromPartial(object.programInfo)
            : undefined;
        return message;
    },
};
function createBaseSdkZapi_Player_PlayRecording() {
    return { id: 0, options: undefined, programInfo: undefined };
}
export const SdkZapi_Player_PlayRecording = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== 0) {
            writer.uint32(8).uint32(message.id);
        }
        if (message.options !== undefined) {
            SdkZapi_PlayOptions.encode(message.options, writer.uint32(18).fork()).ldelim();
        }
        if (message.programInfo !== undefined) {
            SdkZapi_Player_ProgramInfo.encode(message.programInfo, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdkZapi_Player_PlayRecording();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.id = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.options = SdkZapi_PlayOptions.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.programInfo = SdkZapi_Player_ProgramInfo.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.Number(object.id) : 0,
            options: isSet(object.options) ? SdkZapi_PlayOptions.fromJSON(object.options) : undefined,
            programInfo: isSet(object.programInfo) ? SdkZapi_Player_ProgramInfo.fromJSON(object.programInfo) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        if (message.options !== undefined) {
            obj.options = SdkZapi_PlayOptions.toJSON(message.options);
        }
        if (message.programInfo !== undefined) {
            obj.programInfo = SdkZapi_Player_ProgramInfo.toJSON(message.programInfo);
        }
        return obj;
    },
    create(base) {
        return SdkZapi_Player_PlayRecording.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdkZapi_Player_PlayRecording();
        message.id = object.id ?? 0;
        message.options = (object.options !== undefined && object.options !== null)
            ? SdkZapi_PlayOptions.fromPartial(object.options)
            : undefined;
        message.programInfo = (object.programInfo !== undefined && object.programInfo !== null)
            ? SdkZapi_Player_ProgramInfo.fromPartial(object.programInfo)
            : undefined;
        return message;
    },
};
function createBaseSdkZapi_Player_PlayVodTrailer() {
    return { teasableType: "", teasableId: "", options: undefined, streamProviderId: undefined };
}
export const SdkZapi_Player_PlayVodTrailer = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.teasableType !== "") {
            writer.uint32(10).string(message.teasableType);
        }
        if (message.teasableId !== "") {
            writer.uint32(18).string(message.teasableId);
        }
        if (message.options !== undefined) {
            SdkZapi_PlayOptions.encode(message.options, writer.uint32(26).fork()).ldelim();
        }
        if (message.streamProviderId !== undefined) {
            writer.uint32(34).string(message.streamProviderId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdkZapi_Player_PlayVodTrailer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.teasableType = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.teasableId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.options = SdkZapi_PlayOptions.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.streamProviderId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            teasableType: isSet(object.teasableType) ? globalThis.String(object.teasableType) : "",
            teasableId: isSet(object.teasableId) ? globalThis.String(object.teasableId) : "",
            options: isSet(object.options) ? SdkZapi_PlayOptions.fromJSON(object.options) : undefined,
            streamProviderId: isSet(object.streamProviderId) ? globalThis.String(object.streamProviderId) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.teasableType !== "") {
            obj.teasableType = message.teasableType;
        }
        if (message.teasableId !== "") {
            obj.teasableId = message.teasableId;
        }
        if (message.options !== undefined) {
            obj.options = SdkZapi_PlayOptions.toJSON(message.options);
        }
        if (message.streamProviderId !== undefined) {
            obj.streamProviderId = message.streamProviderId;
        }
        return obj;
    },
    create(base) {
        return SdkZapi_Player_PlayVodTrailer.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdkZapi_Player_PlayVodTrailer();
        message.teasableType = object.teasableType ?? "";
        message.teasableId = object.teasableId ?? "";
        message.options = (object.options !== undefined && object.options !== null)
            ? SdkZapi_PlayOptions.fromPartial(object.options)
            : undefined;
        message.streamProviderId = object.streamProviderId ?? undefined;
        return message;
    },
};
function longToNumber(long) {
    if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return long.toNumber();
}
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
